import { type AuthenticationMethod } from 'modules/authentication-factor/models/authenticationFactors';
import { postV2ApiCardsPaymentPasswordProcedureId } from 'src/client/spendesk-api';
import { type PostV2ApiCardsPaymentPasswordProcedureIdResponseOK } from 'src/client/spendesk-api-types';

type PostPaymentPasswordProcedureRequestInput = {
  authenticationMethod: AuthenticationMethod;
  procedureId: string;
};

export const postPaymentPasswordProcedure = async ({
  authenticationMethod,
  procedureId,
}: PostPaymentPasswordProcedureRequestInput): Promise<PostV2ApiCardsPaymentPasswordProcedureIdResponseOK> => {
  const response = await postV2ApiCardsPaymentPasswordProcedureId({
    path: { procedureId },
    body: {
      authenticationMethod,
    },
  });
  if (response.statusCode === 200) {
    return response.body;
  }
  throw new Error('Impossible to retrieve payment password');
};
